import * as React from 'react';

export const OnboardingStep1 = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1242 1200"
		{...props}
	>
		<defs>
			<clipPath id="c">
				<path d="M0 0h1242v1200H0z" data-name="Rechteck 1" transform="translate(809 643)" />
			</clipPath>
			<clipPath id="d">
				<path d="M0 0h1242v1200H0z" data-name="Rechteck 2" transform="translate(-3672.5 -.5)" />
			</clipPath>
			<clipPath id="e">
				<ellipse
					cx="1409"
					cy="921.5"
					data-name="Ellipse 6"
					rx="1409"
					ry="921.5"
					transform="translate(-4481.5 -643.5)"
				/>
			</clipPath>
			<linearGradient
				id="a"
				x1="-.002"
				x2="1.001"
				y1=".5"
				y2=".5"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stopColor="#444" />
				<stop offset="1" stopColor="#262626" />
			</linearGradient>
			<linearGradient id="f" x1=".304" x2="-.697" y1=".659" y2=".659" href="#a" />
			<linearGradient
				id="b"
				x1="5.479"
				x2="6.028"
				y1="-.135"
				y2=".685"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stopColor="#444" />
				<stop offset="1" />
			</linearGradient>
			<linearGradient id="g" x1=".001" x2="1.001" y1=".5" y2=".5" href="#a" />
			<linearGradient id="h" x1=".001" x2="1.001" y1=".5" y2=".5" href="#a" />
			<linearGradient id="i" x1="-.002" x2=".998" y1=".5" y2=".5" href="#a" />
			<linearGradient id="j" x2="1" y1=".5" y2=".5" href="#a" />
			<linearGradient id="k" x1=".5" x2=".5" y1="1" gradientUnits="objectBoundingBox">
				<stop offset="0" stopColor="#a5a73a" />
				<stop offset=".177" stopColor="#bcbe6d" />
				<stop offset=".38" stopColor="#d4d5a1" />
				<stop offset=".571" stopColor="#e7e7ca" />
				<stop offset=".743" stopColor="#f4f4e7" />
				<stop offset=".892" stopColor="#fcfcf9" />
				<stop offset="1" stopColor="#fff" />
			</linearGradient>
			<clipPath id="l">
				<path
					d="M-3138.7 812.2c7 0 12.7-6.1 12.7-13.5V457.5c0-7.4-5.7-13.5-12.7-13.5h-185.7c-7 0-12.7 6.1-12.7 13.5v341.2c0 7.4 5.7 13.5 12.7 13.5z"
					data-name="Pfad 148"
				/>
			</clipPath>
			<linearGradient id="m" x1="-.003" x2="1" y1=".499" y2=".499" href="#a" />
			<linearGradient id="n" x1=".385" x2="-.616" y1=".644" y2=".644" href="#a" />
			<linearGradient id="o" x1="5.72" x2="6.269" y1="-.139" y2=".681" href="#b" />
			<linearGradient id="p" x1=".002" x2="1" y1=".5" y2=".5" href="#a" />
			<linearGradient id="q" x1=".001" x2="1" y1=".5" y2=".5" href="#a" />
			<linearGradient id="r" x1=".005" x2="1.004" y1=".501" y2=".501" href="#a" />
			<linearGradient id="s" x2="1" y1=".502" y2=".502" href="#a" />
		</defs>
		<g data-name="Gruppe 26">
			<g clipPath="url(#c)" data-name="Gruppe 1" transform="translate(-809 -643)">
				<ellipse cx="1409" cy="921.5" fill="#e6e6e6" data-name="Ellipse 1" rx="1409" ry="921.5" />
			</g>
			<g clipPath="url(#d)" data-name="Gruppe 25" transform="translate(3672.5 .5)">
				<g clipPath="url(#e)" data-name="Gruppe 6">
					<path
						d="M-2715.7 766.6c2.2 100 45.1 180.1 95.9 179s90.1-83.1 88-183.1c-2.2-100-45.1-180.1-95.9-179-50.8 1.2-90.1 83.2-88 183.1z"
						data-name="Pfad 1"
					/>
					<path
						d="M-2829.6 775.3c2.2 100 45.1 180.1 95.9 179s90.1-83.1 88-183c-2.2-100-45.1-180.1-95.9-179s-90.2 83.1-88 183z"
						data-name="Pfad 2"
					/>
					<path
						d="M-2608.1 944.4s-68.4 13.9-128.6 10.1-40-86.1-13.8-91c26.1-4.9 192.1 30.8 142.4 80.9z"
						data-name="Pfad 3"
					/>
					<path
						fill="#595f62"
						d="M-3557.7 863.7c-2.8 1.5-221.9-152.2-221.9-152.2s-21.8-129.5-14.6-139.6 245.2 119.9 251.3 171.3c6.1 51.5 8.9 107.5-14.8 120.5z"
						data-name="Pfad 4"
					/>
					<path
						fill="#595f62"
						d="M-3619.1 212.1s30.8-20.7 307.4-18.1c229.3 2.2 310.2 42.3 336.5 53.3-44.6-11.6-582.4-15.6-643.9-35.2z"
						data-name="Pfad 5"
					/>
					<path
						fill="#71787c"
						d="M-2523.6 598.1c2.4-1 29.3 18.3 38.3 87.1s-3.1 125-4.6 141.8c-14.1 26.4-14.2 51-69.9 59.1s-487.5 42.9-696.4 32.2c-142.7-5.5-187.1-26.2-187.1-26.2s-34.6-5.6-67.7-120.3-22.1-161.1 2.5-174.1c24.6-13.1 151.6-19.7 234.8-10.3 83.1 9.4 693.7 34.7 750.1 10.7z"
						data-name="Pfad 6"
					/>
					<path
						fill="#595f62"
						d="M-2803.8 370.6s-1.4-7 15-7.4 61.7 3.9 67.5 37.4c4.4 25.2-55.3 19.6-60.2 19.9-5 .5-22.3-49.9-22.3-49.9z"
						data-name="Pfad 7"
					/>
					<path
						fill="#595f62"
						d="M-3816.5 512.7s7.8-28.6 20.4-49.7c12.7-21.1 10.4-54.3 20.9-69 10.4-14.8 23.9-10.4 32.4-27.6 8.5-17.3 37.7-80.7 83.7-128.6s125.7-30.8 137.7-21c43.6-1.7 148.5-8.5 251.4-6.6s235.7 16.8 278.8 29.8c43 13 114.1 64.5 213.1 151.9 33.4 25.9 43.7 35.8 78.8 49.2s102.4 46.8 134.4 78.9 73.9 93.5 11.8 97.6-414.7 26.7-533 18.7-259.3-40.8-287.3-39.8-123.4 8.2-123.4 8.2l-20.2 25.9s4.5 93.7-36.6 84.2c-41.1-9.6-184.2-60.7-218.9-94.4-34.7-33.6-45.9-56.6-44-107.7z"
						data-name="Pfad 8"
					/>
					<path
						fill="#595f62"
						d="M-2919.6 779.1c-2.7-.1-180.7-9.2-197.1-26-13.7-27.1-11.8-62.1-30.6-64.2s-153-14.5-212.7-43.6c-20.1-8.9-52.7-12.6-58.6.5s-40.1 22.2-45.2 22.5c-4.7-19.2-22-87.7-64.4-100.2-42.5-12.5-60.3 76.2-65 108.8-4.6 32.6 90.7 137.5 114.9 156.3s170 66 255.6 62.9 463.2-111.5 303.1-117z"
						data-name="Pfad 9"
					/>
					<path
						fill="#595f62"
						d="M-3150.7 777.5s-181.7-23-209.3-23-29.8 26-36.4 50.8-6.3 50.6-6.3 50.6 265.8-60 252-78.4z"
						data-name="Pfad 10"
					/>
					<path
						fill="url(#a)"
						d="M-3144.6 778s-140.6-10.8-187.2-17.8c-20.8-2.3-45.6-7.6-52.7 20-7.2 27.6-14.9 55.7-17.5 71.3-2.7 15.6-6.2 26.4 9 32.3s91.2 32.1 211 33.7c119.9 1.6 439.2-1.7 578.5-28 139.2-26.3 115.6-70.4 118.8-103.5 3.1-33.1 1.8-60.6-6.9-56.3s-59.5 30.5-99.8 36.9c-40.4 6.4-417.9 13.8-464.3 25.9-11 2.8-62.4-12-88.9-14.5z"
						data-name="Pfad 11"
					/>
					<path
						fill="#595f62"
						d="M-3372 520.6s-54.1-11-54.7-3.8c-.6 7.1 3.4 45.7 25.6 82.3s32.3 47.5 64.2 56.9c32 9.4 145.9 35.6 268.7 38.2 249.3 5.2 456.3-10.9 503.4-20.3 105.2-21.1 52.3-71.4 26.2-77.1s-629.2 22.8-625.9 21.8-181.7-69.8-197.5-82.2c-15.7-12.4-10-15.8-10-15.8z"
						data-name="Pfad 12"
					/>
					<path
						fill="#595f62"
						d="M-3582.7 623.8s4.5-23.1-25.7-43.8c-30.2-20.8-152.2-89.4-163.9-85s-33.6 17.8-12.4 83.5 212.8 99.8 202 45.3z"
						data-name="Pfad 13"
					/>
					<path
						fill="url(#f)"
						d="M-2601.4 591s-388.8 20.6-533.6 9.1c-89.9 35.8 7.6 61 7.6 61s316.7 6.2 515.6-16.7c56.2-52.9 10.4-53.4 10.4-53.4z"
						data-name="Pfad 14"
					/>
					<path
						fill="url(#b)"
						d="M-3541.5 447s4.1-70.6.1-130.1-1.8-79.8-14-91.3-69-7.7-90.9 7.8-87.8 106.9-92.4 143.2c1.3 6.1 34.3 27.6 175.1 70.1 10.9 3.7 20.1 9.2 22.1.3z"
						data-name="Pfad 15"
					/>
					<path
						fill="#1e2021"
						d="M-3546.5 447a3.118 3.118 0 0 0 .2-.7c.3-6.1 3.8-73 .1-129-.9-12.9-1.4-23.9-1.9-33.5-1.7-33.2-2.4-46.9-10.6-54.6-3.6-3.4-16.5-6.4-36.4-5.1s-38.9 6.5-48.4 13.3c-20.5 14.6-84.1 102.3-90.2 138.4 3.2 3.4 26.7 22.7 171.5 66.4 2.1.7 4 1.4 5.8 2.1 3.7 1.4 7.6 2.9 9.5 2.8a1.573 1.573 0 0 1 .4-.1z"
						data-name="Pfad 16"
					/>
					<path
						fill="#333535"
						d="M-2991.8 243.5s86.4 43.5 240.1 174.7c-22.3 7.6-213.9 21.2-360.7 19.6-146.9-1.7-386.7-1.5-389.7-33-3-31.4-13.6-178.3-13.6-178.3s180.2-12 304.7-3.6c124.4 8.4 174.9 13.9 219.2 20.6z"
						data-name="Pfad 17"
					/>
					<path
						fill="#1e2021"
						d="M-2992.2 243.9s140.5 110.7 196.9 165.8c3.9 5.9 8.4 7.4-10.1 6.8-18.5-.5-185.6 9.7-353 4.1-167.3-5.6-307.8-16.4-313.5-23.1-5.7-6.6-9.3-7.3-26.2-169.6 54.3-2.7 272.8-13.3 505.9 16z"
						data-name="Pfad 18"
					/>
					<path
						fill="#595f62"
						d="M-2489.9 827s-11.3 67.5-44.9 78.6c-38.3 5.2-674.6 43.1-726.4 43-51.9-.1-123-12.9-149.8-19.9-25.1-21.2-34.3-39.9-34.3-39.9a451.051 451.051 0 0 1-12.6-71.2c38.8 28.2 55 34.1 55 34.1s-6.3 25 3.6 27.9 126.1 60.1 537.1 29.3c153-9.4 347.1-11.7 372.3-81.9z"
						data-name="Pfad 19"
					/>
					<path
						fill="#262626"
						d="M-3370.5 785.3s-19.4 51.4-12.2 54.4 169.2 21.3 238.3 29c10.6.2 31 30.4 73.3 32s152.2 3.1 291.4-5.3 195.3-22.7 207.7-34.9 11.8-20.1 27.2-26.4 55-18.6 54.9-46.7 1-37.8-13.6-32.5c-14.6 5.4-65 26.3-70.5 23.1-5.5-3.1 5.1-15.3-15-13.9-20.1 1.3-133.9 8-246.2 11.1s-250.1 5.2-258.5 10.2c-8.5 5-13.2 13.2-34.4 11.9-21.1-1.2-219.4-22.3-242.4-12z"
						data-name="Pfad 20"
					/>
					<path
						fill="#595f62"
						d="M-3162.3 811s19.3 39.1 18.6 41.8-139.6-10.9-227.7-27.9c-4.8-6.7 6.9-28.6 6.9-28.6s112.7 4 202.2 14.7z"
						data-name="Pfad 21"
					/>
					<path
						fill="#b3b8ba"
						d="M-3150.2 848.3c-3-7.1-9.2-20.4-15.3-32.8-79.6-9.4-177.7-13.5-196.2-14.2-3.8 7.7-6.4 15.9-6.2 19.4 77.4 14.7 190.6 26.5 217.7 27.6z"
						data-name="Pfad 22"
					/>
					<path
						fill="#595f62"
						d="M-2495.9 762.2s1.7 15.5.7 21.9c-6.5 6.3-17.5 21-62.7 35.7.1-6.4 2.8-33.1 2.8-33.1s51.6-18.9 59.2-24.5z"
						data-name="Pfad 23"
					/>
					<path
						fill="#b3b8ba"
						d="M-2552.7 812.9c34.4-12.1 45.8-23.7 52-30.1l.9-.9a100.833 100.833 0 0 0-.3-12c-13.8 6.5-41.1 16.7-50.6 20.2-.4 5.1-1.4 15.4-2 22.8z"
						data-name="Pfad 24"
					/>
					<path
						fill="#595f62"
						d="M-2571 781.8s.9 77.3-54.1 88.3-158.8 17.4-224.9 20.2-190.3 11.1-206.7-6.8c-16.4-17.8-40.5-39.9-54.7-87.4 10.4 14 42 78.2 64.1 86.2s167.5 3.1 226.8.2 184.9-12.3 202.7-21.4c17.8-8.9 29.6-14.4 46.8-79.3z"
						data-name="Pfad 25"
					/>
					<path
						fill="#595f62"
						d="M-2730.5 427.3s75.7 27.5 94.3 64.9 22.8 70.1 17.1 99.4c19.6.4 26.1-.8 26.1-.8l29.4-65.5s-38.1-35.4-86.9-59.8c-48.7-24.4-80-38.2-80-38.2z"
						data-name="Pfad 26"
					/>
					<path
						d="M-3581.9 223.6s-45.6 63.1-79.3 167.6c-21.2-7.9-21.1-10.3-21.1-10.3s33-89.7 86.3-157.1c12-.4 14.1-.2 14.1-.2z"
						data-name="Pfad 27"
					/>
					<path
						fill="#595f62"
						d="M-3583.2 218.5s-45.6 63.1-79.3 167.6c-21.2-7.9-21.1-10.3-21.1-10.3s33.8-89.1 87.1-156.4c12-.5 13.3-.9 13.3-.9z"
						data-name="Pfad 28"
					/>
					<path
						fill="#71787c"
						d="M-2788.1 435.3s-157.3 12.7-282.7 10.9c-125.4-1.9-262.7-4.6-256.1 1.7 6.7 6.4 137.2 69.1 129.3 77-8 7.9-251.5-82.5-270.2-90.9s-43-32.3-49.7-30.7 8.1 19.3 41.2 39.8 61.7 32.7 84.1 72.1c23 4.1 31.6 7 31.6 7s-1.2-27.1-71.2-65.5c43 24.3 237.8 97.6 291.9 110.4 8.7 2.3-41.5-52.8-105.8-82.5s192.4 12.4 283.2 22.6c222.2 24.9 327.4 66.4 327.4 47.4-.1-43.6-296.6-79.5-270.6-96.5 27.5-18.1 114.7-16.3 117.6-22.8z"
						data-name="Pfad 29"
					/>
					<path
						fill="#71787c"
						d="M-3541.1 456.5s8.2 20.4-22.2 7.1-148.1-53.1-172.9-60.5c-24.9-7.4-36-4.4-41.6 5 .9-12.5 5.5-20.2 49.4-7.8s147.4 50.9 164.8 57.1c17.3 6.2 20.7 6.6 22.5-.9z"
						data-name="Pfad 30"
					/>
					<path
						fill="#71787c"
						d="M-3524.4 598.8s-42.8-35.8-52.1 9.6c-9 23.4-.6 4.4-15-1.6-14.5-6.1-177.3-115.6-184.2-87.1-6.9 28.6-2.5 67.8-2.5 67.8s-14.1-120.3-37-81 3.3 142.1 9.5 182.1 35.1 25.8 52.1 17.6 27.6-21.2 63.8 8.1c36.2 29.2 106.6 84.3 103.2 45-3.5-39.3.8-40.5 4.6-36.3 3.8 4.1 50.7-43.8 57.6-124.2z"
						data-name="Pfad 31"
					/>
					<path
						fill="#595f62"
						d="M-3596.8 693.3s-166-125.5-170.1-112.1 11.5 54.6 32.5 75.9c21.1 21.3 134.3 111.2 140.2 108.5 5.8-2.6-1.9-39.1-2.6-72.3z"
						data-name="Pfad 32"
					/>
					<path
						d="M-2528.7 901.6a14.513 14.513 0 0 0-11.8-7.7c-8.5-.6-214.3 17.1-307.4 22.1-93.2 5.1-322.6 7.8-354.4 14.5-31.9 6.7-29 16.1-62.3 17.2 153.4-3.4 294.1-10.5 438.7-17.8 144.5-7.4 299.4-12.6 297.2-28.3z"
						data-name="Pfad 33"
					/>
					<path
						fill="url(#g)"
						d="M-3555.8 466.5s-41 40.1-37.7 234.3c-12.6-190.1 37.7-234.3 37.7-234.3z"
						data-name="Pfad 34"
					/>
					<path
						fill="url(#h)"
						d="M-3680.1 421.5s-41.5 23.2-25.7 201.2c5.5 40.4 14.1 67.1-.4 79.9 3-14.4 7.7-20.9-2.4-69.6-9.9-48.5-10-194.2 28.5-211.5z"
						data-name="Pfad 35"
					/>
					<path
						fill="#262626"
						d="M-3422.6 517.3s41.9-3.7 91.4 13.3c49.5 16.9 240.4 87.7 240.4 87.7l-36.7 42.9s-132.2-5.3-183.2-20.3c-51.1-15.1-59.1-16.3-75.6-40.7-16.6-24.5-44-79.7-36.3-82.9z"
						data-name="Pfad 36"
					/>
					<path
						fill="#929a9f"
						d="M-3094 619.1c-23-8.5-192.1-71.1-237.8-86.7-44.7-15.3-82.7-13.7-89.8-13.2h-.3c-3.2 5.1 19.1 53.3 37.2 79.9 15.3 22.5 23.1 24.8 66.7 37.6l7.9 2.3c48 14.2 169.9 19.7 181.8 20.2z"
						data-name="Pfad 37"
					/>
					<path
						fill="#262626"
						d="M-2564.8 520s-30.2 61.8-47.8 87.5c2.4 23.6.7 36.9.7 36.9s16.4 8.6 28.6 7.8 64.7-31.5 63.5-62.2c-1.1-30.7-38.4-70-45-70z"
						data-name="Pfad 38"
					/>
					<path
						fill="#929a9f"
						d="M-2583.4 650.3c11.8-.8 62.8-30.8 61.7-60.2-1.1-28.5-33.9-64.1-42.1-67.8-4.6 9.3-30.8 62.1-46.8 85.8 1.9 19.1 1.1 31.3.8 35.2 3.9 1.9 16.7 7.6 26.4 7z"
						data-name="Pfad 39"
					/>
					<path
						d="M-2616.8 607.8s-243.3 15.6-469.8 11.9c1.8 11.7 4 18.5 7.6 38.5 20.9 1.5 344.6-1.5 461.6-16.8 0-16.2.6-33.6.6-33.6z"
						data-name="Pfad 40"
					/>
					<path
						fill="#1e2021"
						d="M-3588.7 220s-50.7 64.4-78.4 146.1l-2.1.6s25.2-80.2 80.5-146.7z"
						data-name="Pfad 41"
					/>
					<path
						fill="#4a4e4f"
						d="M-3542.9 345.2s-12.9 53.6-22.7 68c0 0-87.3 11-140.4-5.4 1.2 7-1.3 21.7 44 23.8s100.5 10.7 115.6 20c2.6 1.3 5.8-46.5 3.5-106.4z"
						data-name="Pfad 42"
					/>
					<path
						fill="#4a4e4f"
						d="M-3583.3 415.6c1-.1 5.5-43-3.4-54.7s-33.4-8.8-61.6-4.7-63 12.8-60.1 35.9c1.6 12.4 2.5 15.8 2.5 15.8s41 12.6 122.6 7.7z"
						data-name="Pfad 43"
					/>
					<path
						fill="#4a4e4f"
						d="M-3640.6 224.3c-1 .7 39.5-28.1 111.7-7.8 11 4 8.7 82.6 13.3 128.5s11 57.8 6.3 52.1c-4.8-5.7-8.4-25.3-11.8-52.2-3.4-26.8-4.1-121.9-11.9-125.4-7.8-3.4-77.1-15.2-107.6 4.8z"
						data-name="Pfad 44"
					/>
					<path
						fill="#71787c"
						d="M-2517.8 605.4c-1.2-1.5-13.1 47.5-72.3 56.3-14.4 2 54.3 1.6 71.5-9.9 17.3-11.6 19.7-21.8.8-46.4z"
						data-name="Pfad 45"
					/>
					<path
						fill="#71787c"
						d="M-3543.5 356.9s-11.3 52-22.1 58.2c-9.6 2.1-66.9 5.9-116.5-.7 17.5 9.2 105.7 9.2 117.9 3.3 12.3-5.8 17.7-39.1 20.7-60.8z"
						data-name="Pfad 46"
					/>
					<path
						fill="#fff"
						d="M-3135.8 614.1s-201-86.8-281.6-91.4c-1 1.9 26.9 17.4 26.9 17.4s-1.6 48.4 42.9 80c-14.6-20.8-28.7-38.2-33.1-76.3 15.5 5.2 50 15.5 50 15.5s-23.1 7.1-18.9 37.4 68.4 41.9 98.4 39.1c-30.1-24.4-41.9-31.1-41.9-31.1s-.9-30.9 50.3-18.8c51.4 12.1 108 27.8 107 28.2z"
						data-name="Pfad 47"
					/>
					<path
						fill="#fff"
						d="M-2559.5 527.9c-.1-1.6 39.3 54.5-2 86.7 1-13-18.9-30.1-33.8-26.1 13.3-21.9 35.8-59.5 35.8-60.6z"
						data-name="Pfad 48"
					/>
					<path
						fill="#b3b8ba"
						d="M-3180.7 625.5c-.6-.6 18.4 11.3 38.9 24.9-10 1.2-47.7-1.2-72.6-6.6 26.7-.5 47.6-5.7 33.7-18.3z"
						data-name="Pfad 49"
					/>
					<path
						fill="url(#i)"
						d="M-3760.6 399.5s-29.1 43.4-25.8 120.9c-.4-76.7 25.8-120.9 25.8-120.9z"
						data-name="Pfad 50"
					/>
					<g data-name="Gruppe 2">
						<path
							fill="#595f62"
							d="M-2720.9 790.9c85.7-5.7 139.2-11.4 140.2-11.6l-.4-3.4c-2.2.2-226.6 24.4-497 22.7v3.4c139.3 1 266.4-5 357.2-11.1z"
							data-name="Pfad 51"
						/>
					</g>
					<g data-name="Gruppe 3">
						<path
							fill="#595f62"
							d="M-2693.4 812.4c45.1-3 81.2-5.9 104.9-7.9 2.2-.2 3.5-.3 3.8-.3l-.2-3.4q-.6 0-3.9.3c-74.7 6.3-271.8 21.1-488.5 22.1v3.4c148.1-.6 286.9-7.7 383.9-14.2z"
							data-name="Pfad 52"
						/>
					</g>
					<g data-name="Gruppe 4">
						<path
							fill="#595f62"
							d="M-2716.3 833.7c73.4-4.9 124.8-9.1 126-9.2l-.3-3.4c-2.8.2-286 23.6-478.8 23.9v3.4c111.3-.2 252.8-8.1 353.1-14.7z"
							data-name="Pfad 53"
						/>
					</g>
					<g data-name="Gruppe 5">
						<path
							fill="#595f62"
							d="M-2686.3 854.9c38.9-2.6 68.8-4.7 82.6-5.7l1.5-.1-.2-3.4-1.5.1c-50 3.7-306.7 22-450.4 22.8v3.4c103.9-.7 266.7-10.4 368-17.1z"
							data-name="Pfad 54"
						/>
					</g>
					<path
						fill="url(#j)"
						d="M-2630.5 586.3c2.5-.2-319.1 23.7-504.5 11-142.1-52.4-204.4-72.4-219.7-76.4 41.1 3.1 220.1 69.7 220.1 69.7s215.6 14.9 504.1-4.3z"
						data-name="Pfad 55"
					/>
					<circle
						cx="10.2"
						cy="10.2"
						r="10.2"
						fill="#c94c38"
						data-name="Ellipse 2"
						transform="translate(-3264.7 596)"
					/>
					<path
						fill="#c94c38"
						d="M-2566.1 602.5a10.179 10.179 0 0 1-10.2-10.2 10.179 10.179 0 0 1 10.2-10.2 10.179 10.179 0 0 1 10.2 10.2 10.243 10.243 0 0 1-10.2 10.2"
						data-name="Pfad 56"
					/>
					<circle
						cx="5.7"
						cy="5.7"
						r="5.7"
						fill="#fff"
						data-name="Ellipse 3"
						transform="translate(-3228.7 610.7)"
					/>
					<circle
						cx="5.7"
						cy="5.7"
						r="5.7"
						fill="#fff"
						data-name="Ellipse 4"
						transform="translate(-2759.3 706.5)"
					/>
					<circle
						cx="5.7"
						cy="5.7"
						r="5.7"
						fill="#fff"
						data-name="Ellipse 5"
						transform="translate(-2589.5 610)"
					/>
					<path
						d="M-3805.7 797.4s9.4 14.4 48.5 14.1 51.2-7 53-48.5c-24.3-15.4-45.8-31.3-45.8-31.3s-15.3-9.2-17.3-39.1-7.9-49.9-16.1-97-16.2-73.2-25.7-70.8c-9.5 2.3-13 42.8-10.2 67.6 2.6 24.7 10 193.9 13.6 205z"
						data-name="Pfad 57"
					/>
					<path
						d="M-3576.9 762.7s-17.1-172.3 41.5-168.8 73.9 173.6 76.6 222.2c5.5 48.9 9.2 62.3 15.2 74.4 5.9 12.1 25.6 35.1 34.3 38.5s61.4 11.2 61.4 11.2-5.2 42.5-37.7 48.1c-39.9 7-118.7 3.1-139.5-2.9-20.9-6-49.5-214.4-51.8-222.7z"
						data-name="Pfad 58"
					/>
					<path
						fill="#595f62"
						d="M-3828.7 675.7c.7 71 15.7 128.4 33.4 128.2s31.5-57.9 30.8-128.9-15.7-128.4-33.4-128.2-31.5 57.9-30.8 128.9z"
						data-name="Pfad 59"
					/>
					<path
						fill="#595f62"
						d="M-3575.8 806.2c2.2 100 27 180.5 55.3 179.9 28.4-.6 49.6-82.2 47.4-182.2s-27-180.5-55.3-179.9c-28.4.7-49.6 82.2-47.4 182.2z"
						data-name="Pfad 60"
					/>
					<path
						fill="#595f62"
						d="M-3570 808.5c1.9 85.1 21.4 153.7 43.6 153.2s38.7-69.9 36.9-155c-1.9-85.1-21.4-153.7-43.6-153.2s-38.7 69.9-36.9 155z"
						data-name="Pfad 61"
					/>
					<path
						fill="#333535"
						d="M-3568.1 808.4c1.8 81.2 20.4 146.7 41.6 146.2s37-66.7 35.2-147.9-20.4-146.7-41.6-146.2c-21.3.5-37 66.7-35.2 147.9z"
						data-name="Pfad 62"
					/>
					<path
						d="M-3531.8 807.3c.4 18.7 4.7 33.7 9.6 33.6s8.5-15.3 8.1-34-4.7-33.7-9.6-33.6c-4.9.2-8.5 15.4-8.1 34z"
						data-name="Pfad 63"
					/>
					<path
						fill="#595f62"
						d="M-3824.7 675.6c.6 58.8 9.6 106.3 20 106.2 10.5-.1 18.5-47.8 17.9-106.6s-9.6-106.3-20-106.2c-10.5.1-18.5 47.9-17.9 106.6z"
						data-name="Pfad 64"
					/>
					<path
						fill="#333535"
						d="M-3823.7 675.6c.6 55.4 9 100.3 18.9 100.2s17.4-45.1 16.9-100.6c-.6-55.5-9-100.3-18.9-100.2-9.9.2-17.4 45.2-16.9 100.6z"
						data-name="Pfad 65"
					/>
					<path
						d="M-3803.6 675.1c.2 14.4 2.3 26 4.9 26s4.5-11.7 4.4-26.1-2.3-26-4.9-26-4.6 11.7-4.4 26.1z"
						data-name="Pfad 66"
					/>
					<path
						fill="#262626"
						d="M-2673 701.7l-302.2 10.8s-8.6-.1-8 8.5 4.5 67.8 4.5 67.8-1.6 6.1 8.3 5.4 302.7-13.6 302.7-13.6 6.5-1.1 5.2-10.9-3.4-60.5-3.4-60.5 2.2-6.1-7.1-7.5z"
						data-name="Pfad 67"
					/>
					<path
						fill="#1e2021"
						d="M-2667.5 697.7l-302.2 10.8s-8.6-.1-8 8.5 4.5 67.8 4.5 67.8-1.6 6.1 8.3 5.4 302.7-13.6 302.7-13.6 6.5-1.1 5.2-10.9-3.4-60.5-3.4-60.5 2.2-6.2-7.1-7.5z"
						data-name="Pfad 68"
					/>
					<path
						fill="#262626"
						d="M-2664.9 771.2c-1.3-9.8-3.4-60.5-3.4-60.5s2.2-6.1-7.1-7.5l-302.2 10.8h-.7c1.6-5.1 7.7-5 7.7-5l302.2-10.8c9.4 1.4 7.1 7.5 7.1 7.5s2 50.7 3.4 60.5c1.3 9.8-5.2 10.9-5.2 10.9s-.7 0-2 .1a14.375 14.375 0 0 0 .2-6z"
						data-name="Pfad 69"
					/>
					<path fill="none" d="M-3449.128 636.49h220.434v130.419h-220.434z" />
				</g>
				<g clipPath="url(#e)" data-name="Gruppe 24">
					<g data-name="Gruppe 18">
						<g data-name="Gruppe 10">
							<path
								fill="#f6bda0"
								d="M-3206.9 925.5l18.7-16.2a131.689 131.689 0 0 0 38-55.8l23.3-66.7-62.1-122.1-144.3 58.1-9-74.2c-8-49.8-28.7-55.4-43-54.7-13.1.6-7 32.9-9.7 51.5 0 0-10.9 73.2-21.2 138.2-7.3 45.9 35.7 145.5 32.5 156.3l-164.4 435.2h229.9c2.5 0 41.6-.1 43.9 0l41.5-398.4a92.492 92.492 0 0 1 25.9-51.2z"
								data-name="Pfad 70"
							/>
							<g data-name="Gruppe 7" opacity=".5">
								<path
									fill="#f6bda0"
									d="M-3182.2 903.8c-4-5.3-7.8-9.1-11.1-13.1-9.8-11.5-24.4-10.2-35.3-3.2 1 4.6 6.4 23.4 12.7 48.5a100.819 100.819 0 0 1 9-10.6l18.7-16.2a76.961 76.961 0 0 0 6-5.4z"
									data-name="Pfad 71"
									opacity=".3"
								/>
							</g>
							<g data-name="Gruppe 9" opacity=".3">
								<path
									fill="#fff"
									d="M-3311.9 724.8l-1.2-10.1 124.1-50 4.5 8.8z"
									data-name="Pfad 72"
								/>
								<g data-name="Gruppe 8">
									<path
										fill="#f6bda0"
										d="M-3362.2 941.8c3.3-10.8-39.7-110.3-32.5-156.3 10.3-65.1 6.4-136.8 6.4-136.8s-2.4-31.4-2.4-51.6c-.3.5-.6 1.1-.9 1.7 0 .1-.1.1-.1.2a11.755 11.755 0 0 0-.7 2v.1c-.2.7-.4 1.5-.6 2.3v.1a20.22 20.22 0 0 0-.4 2.6v.3c-.2 1.8-.4 3.8-.5 5.8v.1c0 1-.1 2.1-.1 3.2q-.15 5.55 0 11.4v6a28.075 28.075 0 0 1-.1 2.9v.4c0 .9-.1 1.8-.1 2.6v.6c-.1.9-.1 1.8-.2 2.7a.749.749 0 0 1-.1.5l-.3 2.7s-10.9 73.2-21.2 138.2c-7.3 45.9 35.7 145.5 32.5 156.3l-164.4 435.1h237.2c-48.5-6.6-170.1-10.8-203.7-34.3z"
										data-name="Pfad 73"
										opacity=".3"
									/>
								</g>
							</g>
							<path
								fill="#f6bda0"
								d="M-3118.9 557l-183.7 155.1 34.5 40.4 183.7-155.1c16.2-13.9 21.7-34.2 12.2-45.3-9.6-11.1-30.5-9-46.7 4.9z"
								data-name="Pfad 74"
							/>
						</g>
						<path
							fill="url(#k)"
							d="M-3139.8 464.3h-137.6S-3126 809.5-3126 801.9V478a13.742 13.742 0 0 0-13.8-13.7z"
							data-name="Pfad 75"
						/>
						<g data-name="Gruppe 16">
							<path
								fill="#bcbec0"
								d="M-3310.1 392.6h157.1c21.2 0 38.3 18.1 38.3 40.5v391c0 22.4-17.2 40.5-38.3 40.5h-166.7c-21.2 0-28.8-18.1-28.8-40.5v-391c0-22.4 17.2-40.5 38.4-40.5z"
								data-name="Pfad 76"
							/>
							<path
								fill="#343b3d"
								d="M-3319.7 860.3c-20.4 0-24.7-19.7-24.7-36.2v-391c0-19.9 15.4-36.2 34.2-36.2h157.1c18.9 0 34.2 16.2 34.2 36.2v391c0 19.9-15.4 36.2-34.2 36.2z"
								data-name="Pfad 77"
							/>
							<path
								fill="#ccc"
								d="M-3138.7 812.2c7 0 12.7-6 12.7-13.5V458.5c0-7.4-5.7-13.5-12.7-13.5h-185.7c-7 0-12.7 6-12.7 13.5v340.2c0 7.4 5.7 13.5 12.7 13.5z"
							/>
							<path
								fill="#fff"
								d="M-3308.9 444l183.9 339.9V458.5c0-8-6.1-14.5-13.7-14.5z"
								opacity=".35"
							/>
							<path
								fill="#bcbec0"
								d="M-3253.7 416.3h44.2c.9 0 1.7 1.1 1.7 2.5s-.7 2.5-1.7 2.5h-44.2c-.9 0-1.7-1.1-1.7-2.5.1-1.4.8-2.5 1.7-2.5z"
								data-name="Pfad 78"
							/>
							<g clipPath="url(#l)" data-name="Gruppe 15">
								<path
									d="M-2923.8 646.3c1 46.8 21.1 84.4 44.9 83.8 23.8-.5 42.2-38.9 41.2-85.7s-21.1-84.4-44.9-83.8c-23.8.5-42.2 38.9-41.2 85.7z"
									data-name="Pfad 79"
								/>
								<path
									d="M-2977.2 650.4c1 46.8 21.1 84.4 44.9 83.8 23.8-.5 42.2-38.9 41.2-85.7s-21.1-84.4-44.9-83.8c-23.8.5-42.2 38.8-41.2 85.7z"
									data-name="Pfad 80"
								/>
								<path
									d="M-2873.4 729.5s-32 6.5-60.2 4.7-18.7-40.3-6.5-42.6c12.2-2.2 89.9 14.5 66.7 37.9z"
									data-name="Pfad 81"
								/>
								<path
									fill="#595f62"
									d="M-3318.2 691.8c-1.3.7-103.9-71.3-103.9-71.3s-10.2-60.6-6.8-65.4 114.8 56.2 117.7 80.2c2.8 24.1 4.1 50.4-7 56.5z"
									data-name="Pfad 82"
								/>
								<path
									fill="#595f62"
									d="M-3347 386.6s14.4-9.7 144-8.5c107.4 1 145.3 19.8 157.6 25-20.8-5.5-272.8-7.3-301.6-16.5z"
									data-name="Pfad 83"
								/>
								<path
									fill="#71787c"
									d="M-2833.9 567.4c1.1-.5 13.7 8.6 17.9 40.8s-1.5 58.5-2.2 66.4c-6.6 12.4-6.6 23.9-32.7 27.7s-228.3 20.1-326.2 15.1c-66.8-2.6-87.7-12.3-87.7-12.3s-16.2-2.6-31.7-56.3-10.4-75.4 1.2-81.6c11.5-6.1 71-9.2 110-4.8 39 4.3 325 16.2 351.4 5z"
									data-name="Pfad 84"
								/>
								<path
									fill="#595f62"
									d="M-2965.1 460.8s-.7-3.3 7-3.5 28.9 1.8 31.6 17.5c2 11.8-25.9 9.2-28.2 9.3-2.3.3-10.4-23.3-10.4-23.3z"
									data-name="Pfad 85"
								/>
								<path
									fill="#595f62"
									d="M-3439.4 527.4s3.6-13.4 9.6-23.3c5.9-9.9 4.9-25.4 9.8-32.3s11.2-4.9 15.2-12.9c4-8.1 17.7-37.8 39.2-60.2 21.6-22.4 58.9-14.4 64.5-9.8 20.4-.8 69.6-4 117.8-3.1s110.4 7.9 130.6 14 53.4 30.2 99.8 71.1c15.6 12.1 20.5 16.7 36.9 23.1 16.5 6.3 48 21.9 63 37s34.6 43.8 5.5 45.7-194.2 12.5-249.6 8.8-121.4-19.1-134.6-18.6c-13.1.5-57.8 3.8-57.8 3.8l-9.5 12.2s2.1 43.9-17.1 39.4-86.3-28.4-102.5-44.2c-16.5-16-21.7-26.8-20.8-50.7z"
									data-name="Pfad 86"
								/>
								<path
									fill="#595f62"
									d="M-3019.3 652.1c-1.3 0-84.6-4.3-92.3-12.2-6.4-12.7-5.5-29.1-14.3-30.1s-71.7-6.8-99.6-20.4c-9.4-4.1-24.7-5.9-27.4.2-2.8 6.2-18.8 10.4-21.2 10.6-2.2-9-10.3-41.1-30.2-46.9s-28.3 35.7-30.4 51c-2.2 15.3 42.5 64.4 53.8 73.2s79.6 30.9 119.7 29.4c40-1.4 216.8-52.2 141.9-54.8z"
									data-name="Pfad 87"
								/>
								<path
									fill="#595f62"
									d="M-3127.6 651.4s-85.1-10.8-98-10.8-14 12.2-17 23.8a101.518 101.518 0 0 0-3 23.7s124.5-28.1 118-36.7z"
									data-name="Pfad 88"
								/>
								<path
									fill="url(#m)"
									d="M-3124.7 651.6s-65.9-5.1-87.7-8.3c-9.8-1.1-21.3-3.6-24.7 9.4-3.4 12.9-7 26.1-8.2 33.4-1.3 7.3-2.9 12.4 4.2 15.1 7.1 2.8 42.7 15.1 98.8 15.8s205.7-.8 270.9-13.1 54.2-33 55.6-48.5c1.5-15.5.8-28.4-3.2-26.4-4.1 2-27.8 14.3-46.8 17.3-18.9 3-195.7 6.5-217.5 12.1-5 1.3-29-5.6-41.4-6.8z"
									data-name="Pfad 89"
								/>
								<path
									fill="#595f62"
									d="M-3231.2 531.1s-25.3-5.1-25.6-1.8 1.6 21.4 12 38.5 15.1 22.2 30.1 26.7c15 4.4 68.3 16.7 125.9 17.9 116.8 2.4 213.7-5.1 235.8-9.5 49.3-9.9 24.5-33.4 12.3-36.1s-294.7 10.7-293.2 10.2-85.1-32.7-92.5-38.5c-7.5-5.9-4.8-7.4-4.8-7.4z"
									data-name="Pfad 90"
								/>
								<path
									fill="#595f62"
									d="M-3329.9 579.4s2.1-10.8-12-20.5-71.3-41.9-76.7-39.8c-5.5 2-15.7 8.3-5.8 39.1 9.8 30.8 99.6 46.7 94.5 21.2z"
									data-name="Pfad 91"
								/>
								<path
									fill="url(#n)"
									d="M-2870.3 564s-182.1 9.6-249.9 4.3c-42.1 16.8 3.5 28.6 3.5 28.6s148.3 2.9 241.5-7.8c26.3-24.8 4.9-25.1 4.9-25.1z"
									data-name="Pfad 92"
								/>
								<path
									fill="url(#o)"
									d="M-3310.6 496.6s1.9-33.1.1-60.9c-1.9-27.9-.8-37.4-6.5-42.8s-32.3-3.6-42.6 3.7c-10.2 7.3-41.1 50.1-43.3 67.1.6 2.8 16.1 12.9 82 32.8 5 1.7 9.3 4.3 10.3.1z"
									data-name="Pfad 93"
								/>
								<path
									fill="#1e2021"
									d="M-3313 496.6a.773.773 0 0 1 .1-.3c.2-2.9 1.8-34.2.1-60.4-.4-6.1-.7-11.2-.9-15.7-.8-15.5-1.1-22-4.9-25.6-1.7-1.6-7.7-3-17-2.4s-18.2 3.1-22.7 6.2c-9.6 6.8-39.4 47.9-42.2 64.8 1.5 1.6 12.5 10.6 80.3 31.1 1 .3 1.9.7 2.7 1 1.8.7 3.6 1.4 4.5 1.3z"
									data-name="Pfad 94"
								/>
								<path
									fill="#333535"
									d="M-3053.1 401.3s40.5 20.4 112.4 81.8c-10.5 3.6-100.2 10-168.9 9.2-68.8-.8-181.1-.7-182.5-15.4s-6.4-83.5-6.4-83.5 84.4-5.6 142.7-1.7c58.2 3.9 81.9 6.4 102.7 9.6z"
									data-name="Pfad 95"
								/>
								<path
									fill="#1e2021"
									d="M-3053.3 401.5s65.8 51.8 92.2 77.7c1.8 2.8 3.9 3.4-4.7 3.2-8.7-.2-86.9 4.5-165.3 1.9s-144.1-7.7-146.8-10.8-4.3-3.4-12.3-79.4c25.4-1.4 127.7-6.4 236.9 7.4z"
									data-name="Pfad 96"
								/>
								<path
									fill="#595f62"
									d="M-2818.1 674.5s-5.3 31.6-21 36.8c-17.9 2.4-316 20.2-340.2 20.1-24.3 0-57.6-6-70.2-9.3-11.8-9.9-16.1-18.7-16.1-18.7a219.284 219.284 0 0 1-5.9-33.4c18.2 13.2 25.8 16 25.8 16s-2.9 11.7 1.7 13.1c4.6 1.3 59.1 28.2 251.5 13.7 71.7-4.3 162.6-5.4 174.4-38.3z"
									data-name="Pfad 97"
								/>
								<path
									fill="#262626"
									d="M-3230.5 655s-9.1 24.1-5.7 25.5 79.3 10 111.6 13.6c4.9.1 14.5 14.3 34.3 15s71.3 1.4 136.5-2.5 91.5-10.6 97.3-16.3 5.5-9.4 12.8-12.4c7.2-2.9 25.8-8.7 25.7-21.9s.5-17.7-6.4-15.2c-6.8 2.5-30.5 12.3-33 10.8-2.6-1.5 2.4-7.2-7-6.5-9.4.6-62.7 3.8-115.3 5.2s-117.1 2.4-121.1 4.8c-4 2.3-6.2 6.2-16.1 5.6-10-.6-102.8-10.5-113.6-5.7z"
									data-name="Pfad 98"
								/>
								<path
									fill="#595f62"
									d="M-3133 667.1s9 18.3 8.7 19.6-65.4-5.1-106.6-13.1c-2.3-3.1 3.2-13.4 3.2-13.4s52.8 1.8 94.7 6.9z"
									data-name="Pfad 99"
								/>
								<path
									fill="#b3b8ba"
									d="M-3127.3 684.5c-1.4-3.3-4.3-9.5-7.1-15.4-37.3-4.4-83.2-6.3-91.9-6.7-1.8 3.6-3 7.4-2.9 9.1 36.1 7 89.2 12.5 101.9 13z"
									data-name="Pfad 100"
								/>
								<path
									fill="#595f62"
									d="M-2820.9 644.2s.8 7.2.4 10.3c-3 2.9-8.2 9.8-29.4 16.7 0-3 1.3-15.5 1.3-15.5s24.2-8.9 27.7-11.5z"
									data-name="Pfad 101"
								/>
								<path
									fill="#b3b8ba"
									d="M-2847.5 668c16.1-5.7 21.4-11.1 24.4-14.1l.4-.4a54.053 54.053 0 0 0-.1-5.6c-6.5 3.1-19.3 7.8-23.7 9.5-.3 2.3-.7 7.1-1 10.6z"
									data-name="Pfad 102"
								/>
								<path
									fill="#595f62"
									d="M-2856 653.4s.4 36.2-25.3 41.4-74.4 8.2-105.3 9.5c-31 1.3-89.1 5.2-96.8-3.2s-19-18.7-25.6-40.9c4.9 6.6 19.7 36.6 30 40.4 10.4 3.7 78.5 1.4 106.2.1 27.8-1.4 86.6-5.8 95-10 8.2-4.3 13.7-6.9 21.8-37.3z"
									data-name="Pfad 103"
								/>
								<path
									fill="#595f62"
									d="M-2930.8 487.4s35.4 12.9 44.2 30.4c8.7 17.5 10.7 32.9 8 46.5 9.2.2 12.2-.4 12.2-.4l13.8-30.7s-17.8-16.6-40.7-28-37.5-17.8-37.5-17.8z"
									data-name="Pfad 104"
								/>
								<path
									d="M-3329.6 392s-21.3 29.6-37.2 78.5c-9.9-3.7-9.9-4.8-9.9-4.8s15.5-42 40.4-73.6c5.8-.2 6.7-.1 6.7-.1z"
									data-name="Pfad 105"
								/>
								<path
									fill="#595f62"
									d="M-3330.1 389.6s-21.3 29.6-37.2 78.5c-9.9-3.7-9.9-4.8-9.9-4.8s15.8-41.7 40.8-73.2a51.606 51.606 0 0 0 6.3-.5z"
									data-name="Pfad 106"
								/>
								<path
									fill="#71787c"
									d="M-2957.7 491.1s-73.7 6-132.4 5.1-123.1-2.2-119.9.8 64.3 32.4 60.5 36.1c-3.7 3.7-117.8-38.6-126.5-42.6-8.8-3.9-20.1-15.1-23.3-14.4-3.1.7 3.8 9 19.3 18.6s28.9 15.3 39.4 33.8c10.8 1.9 14.8 3.3 14.8 3.3s-.6-12.7-33.4-30.7c20.1 11.4 111.4 45.7 136.7 51.7 4.1 1.1-19.4-24.7-49.6-38.7-30.1-13.9 90.1 5.8 132.6 10.6 104 11.7 153.3 31.1 153.3 22.2 0-20.4-138.9-37.2-126.7-45.2 12.9-8.4 53.8-7.6 55.2-10.6z"
									data-name="Pfad 107"
								/>
								<path
									fill="#71787c"
									d="M-3310.4 501s3.8 9.6-10.4 3.3c-14.2-6.2-69.3-24.9-81-28.3-11.6-3.5-16.9-2.1-19.5 2.4.4-5.9 2.6-9.5 23.1-3.7 20.6 5.8 69 23.8 77.2 26.7 8.1 3 9.7 3.1 10.6-.4z"
									data-name="Pfad 108"
								/>
								<path
									fill="#71787c"
									d="M-3302.6 567.7s-20-16.8-24.4 4.5c-4.2 11-.3 2.1-7-.8-6.8-2.8-83-54.2-86.3-40.8-3.2 13.4-1.2 31.8-1.2 31.8s-6.6-56.4-17.3-37.9c-10.7 18.4 1.5 66.6 4.4 85.3s16.4 12.1 24.4 8.3 12.9-9.9 29.9 3.8 50 39.5 48.3 21.1c-1.6-18.4.4-19 2.2-17 1.8 1.8 23.8-20.7 27-58.3z"
									data-name="Pfad 109"
								/>
								<path
									fill="#595f62"
									d="M-3336.5 612s-77.8-58.8-79.7-52.5 5.4 25.6 15.2 35.6c9.9 10 62.9 52.1 65.6 50.8 2.8-1.3-.8-18.4-1.1-33.9z"
									data-name="Pfad 110"
								/>
								<path
									d="M-2836.2 709.5a6.728 6.728 0 0 0-5.5-3.6c-4-.3-100.4 8-144 10.4s-151.1 3.7-166 6.8-13.6 7.5-29.2 8c71.8-1.6 137.7-4.9 205.5-8.4 67.6-3.4 140.2-5.8 139.2-13.2z"
									data-name="Pfad 111"
								/>
								<path
									fill="url(#p)"
									d="M-3317.3 505.7s-19.2 18.8-17.7 109.8c-5.9-89.1 17.7-109.8 17.7-109.8z"
									data-name="Pfad 112"
								/>
								<path
									fill="url(#q)"
									d="M-3375.5 484.6s-19.5 10.9-12.1 94.3c2.6 18.9 6.6 31.4-.2 37.4 1.4-6.7 3.6-9.8-1.1-32.6-4.6-22.7-4.7-90.9 13.4-99.1z"
									data-name="Pfad 113"
								/>
								<path
									fill="#262626"
									d="M-3254.9 529.5a115.743 115.743 0 0 1 42.8 6.2c23.2 7.9 112.6 41.1 112.6 41.1l-17.2 20.1s-61.9-2.5-85.8-9.5c-23.9-7.1-27.7-7.6-35.4-19-7.8-11.5-20.6-37.4-17-38.9z"
									data-name="Pfad 114"
								/>
								<path
									fill="#929a9f"
									d="M-3101 577.2c-10.8-4-90-33.3-111.4-40.6a114.319 114.319 0 0 0-42.1-6.2h-.1c-1.5 2.4 9 24.9 17.4 37.4 7.2 10.5 10.8 11.6 31.2 17.6l3.7 1.1c22.5 6.6 79.6 9.2 85.2 9.5z"
									data-name="Pfad 115"
								/>
								<path
									fill="#262626"
									d="M-2853.2 530.8s-14.1 28.9-22.4 41c1.1 11 .3 17.3.3 17.3s7.7 4 13.4 3.6 30.3-14.8 29.8-29.1c-.5-14.4-18-32.8-21.1-32.8z"
									data-name="Pfad 116"
								/>
								<path
									fill="#929a9f"
									d="M-2861.9 591.8c5.5-.4 29.4-14.4 28.9-28.2-.5-13.4-15.9-30-19.7-31.7-2.1 4.3-14.4 29.1-21.9 40.2a98.409 98.409 0 0 1 .4 16.5c1.8.8 7.8 3.5 12.3 3.2z"
									data-name="Pfad 117"
								/>
								<path
									d="M-2877.5 571.9s-113.9 7.3-220 5.6c.8 5.5 1.9 8.7 3.6 18 9.8.7 161.4-.7 216.2-7.9-.1-7.5.2-15.7.2-15.7z"
									data-name="Pfad 118"
								/>
								<path
									fill="#1e2021"
									d="M-3332.7 390.3s-23.7 30.2-36.7 68.4l-1 .3s11.8-37.6 37.7-68.7z"
									data-name="Pfad 119"
								/>
								<path
									fill="#4a4e4f"
									d="M-3311.3 448.9s-6 25.1-10.6 31.8c0 0-40.9 5.1-65.7-2.5.6 3.3-.6 10.1 20.6 11.1s47.1 5 54.1 9.4c1.2.7 2.7-21.7 1.6-49.8z"
									data-name="Pfad 120"
								/>
								<path
									fill="#4a4e4f"
									d="M-3330.2 481.9c.5 0 2.6-20.2-1.6-25.6-4.2-5.5-15.7-4.1-28.9-2.2s-29.5 6-28.2 16.8a52.079 52.079 0 0 0 1.2 7.4s19.3 5.9 57.5 3.6z"
									data-name="Pfad 121"
								/>
								<path
									fill="#4a4e4f"
									d="M-3357 392.3c-.5.3 18.5-13.2 52.3-3.7 5.2 1.9 4.1 38.7 6.2 60.2 2.2 21.5 5.2 27.1 2.9 24.4-2.2-2.6-4-11.9-5.5-24.4-1.6-12.6-1.9-57.1-5.6-58.7-3.6-1.7-36-7.2-50.3 2.2z"
									data-name="Pfad 122"
								/>
								<path
									fill="#71787c"
									d="M-2831.1 570.8c-.6-.7-6.1 22.2-33.8 26.4-6.7.9 25.5.7 33.5-4.7s9.1-10.2.3-21.7z"
									data-name="Pfad 123"
								/>
								<path
									fill="#71787c"
									d="M-3311.6 454.4s-5.3 24.4-10.3 27.3c-4.5 1-31.3 2.8-54.6-.3 8.2 4.3 49.5 4.3 55.2 1.6 5.8-2.9 8.3-18.4 9.7-28.6z"
									data-name="Pfad 124"
								/>
								<path
									fill="#fff"
									d="M-3120.6 574.9s-94.1-40.7-131.9-42.8c-.5.9 12.6 8.1 12.6 8.1a47.468 47.468 0 0 0 20.1 37.5c-6.9-9.7-13.4-17.9-15.5-35.7 7.2 2.5 23.4 7.2 23.4 7.2s-10.8 3.3-8.8 17.5 32 19.6 46.1 18.3c-14.1-11.4-19.6-14.6-19.6-14.6s-.4-14.5 23.6-8.8c23.9 5.7 50.5 13.1 50 13.3z"
									data-name="Pfad 125"
								/>
								<path
									fill="#fff"
									d="M-2850.7 534.5c-.1-.8 18.4 25.5-.9 40.6.5-6.1-8.9-14.1-15.8-12.2 6.2-10.3 16.7-27.9 16.7-28.4z"
									data-name="Pfad 126"
								/>
								<path
									fill="#b3b8ba"
									d="M-3141.6 580.2c-.3-.3 8.6 5.3 18.2 11.7-4.7.6-22.3-.6-34-3.1 12.5-.3 22.3-2.7 15.8-8.6z"
									data-name="Pfad 127"
								/>
								<path
									fill="url(#r)"
									d="M-3413.3 474.3s-13.6 20.3-12.1 56.6c-.1-35.9 12.1-56.6 12.1-56.6z"
									data-name="Pfad 128"
								/>
								<g data-name="Gruppe 11">
									<path
										fill="#595f62"
										d="M-2926.3 657.7c40.1-2.7 65.2-5.4 65.7-5.4l-.2-1.6c-1 .1-106.1 11.4-232.8 10.6v1.6c65.3.4 124.8-2.4 167.3-5.2z"
										data-name="Pfad 129"
									/>
								</g>
								<g data-name="Gruppe 12">
									<path
										fill="#595f62"
										d="M-2913.4 667.7c21.1-1.4 38-2.7 49.2-3.7a17.362 17.362 0 0 1 1.8-.1l-.1-1.6c-.2 0-.8.1-1.8.2-35 3-127.3 9.9-228.8 10.4v1.6c69.2-.4 134.3-3.8 179.7-6.8z"
										data-name="Pfad 130"
									/>
								</g>
								<g data-name="Gruppe 13">
									<path
										fill="#595f62"
										d="M-2924.1 677.7c34.4-2.3 58.4-4.3 59-4.3l-.1-1.6c-1.3.1-134 11.1-224.2 11.2v1.6c52-.1 118.3-3.8 165.3-6.9z"
										data-name="Pfad 131"
									/>
								</g>
								<g data-name="Gruppe 14">
									<path
										fill="#595f62"
										d="M-2910.1 687.6c18.2-1.2 32.2-2.2 38.7-2.7l.7-.1-.1-1.6h-.7c-23.4 1.7-143.6 10.3-211 10.7v1.6c48.7-.2 125-4.7 172.4-7.9z"
										data-name="Pfad 132"
									/>
								</g>
								<path
									fill="url(#s)"
									d="M-2883.9 561.8c1.2-.1-149.5 11.1-236.3 5.1-66.6-24.5-95.7-33.9-102.9-35.8 19.3 1.5 103.1 32.7 103.1 32.7s100.9 7 236.1-2z"
									data-name="Pfad 133"
								/>
								<circle
									cx="4.8"
									cy="4.8"
									r="4.8"
									fill="#c94c38"
									data-name="Ellipse 7"
									transform="translate(-3181 566.3)"
								/>
								<path
									fill="#c94c38"
									d="M-2853.8 569.4a4.8 4.8 0 0 1-4.8-4.8 4.739 4.739 0 0 1 4.8-4.8 4.8 4.8 0 0 1 4.8 4.8 4.739 4.739 0 0 1-4.8 4.8"
									data-name="Pfad 134"
								/>
								<circle
									cx="2.7"
									cy="2.7"
									r="2.7"
									fill="#fff"
									data-name="Ellipse 8"
									transform="translate(-3164.1 573.2)"
								/>
								<circle
									cx="2.7"
									cy="2.7"
									r="2.7"
									fill="#fff"
									data-name="Ellipse 9"
									transform="translate(-2944.3 618.1)"
								/>
								<circle
									cx="2.7"
									cy="2.7"
									r="2.7"
									fill="#fff"
									data-name="Ellipse 10"
									transform="translate(-2864.8 572.9)"
								/>
								<path
									d="M-3434.4 660.7s4.4 6.8 22.7 6.6 24-3.3 24.8-22.7c-11.4-7.2-21.4-14.7-21.4-14.7s-7.2-4.3-8.1-18.3-3.7-23.4-7.5-45.4c-3.9-22-7.6-34.3-12-33.2s-6.1 20.1-4.8 31.6c1.2 11.6 4.7 90.9 6.3 96.1z"
									data-name="Pfad 135"
								/>
								<path
									d="M-3327.2 644.4s-8-80.7 19.4-79.1c27.5 1.6 34.6 81.3 35.9 104.1 2.6 22.9 4.3 29.2 7.1 34.8 2.8 5.7 12 16.5 16.1 18 4.1 1.6 28.8 5.3 28.8 5.3s-2.4 19.9-17.7 22.6c-18.7 3.3-55.6 1.4-65.3-1.4-9.8-2.7-23.2-100.3-24.3-104.3z"
									data-name="Pfad 136"
								/>
								<path
									fill="#595f62"
									d="M-3445.1 603.7c.3 33.3 7.3 60.1 15.6 60.1 8.3-.1 14.8-27.1 14.4-60.4-.3-33.3-7.3-60.1-15.6-60.1-8.3.1-14.8 27.1-14.4 60.4z"
									data-name="Pfad 137"
								/>
								<path
									fill="#595f62"
									d="M-3326.7 664.8c1 46.8 12.6 84.6 25.9 84.3s23.2-38.5 22.2-85.3-12.6-84.6-25.9-84.3-23.2 38.5-22.2 85.3z"
									data-name="Pfad 138"
								/>
								<path
									fill="#595f62"
									d="M-3324 665.9c.9 39.9 10 72 20.4 71.8s18.1-32.7 17.3-72.6c-.9-39.9-10-72-20.4-71.8s-18.1 32.7-17.3 72.6z"
									data-name="Pfad 139"
								/>
								<path
									fill="#333535"
									d="M-3323.1 665.9c.8 38 9.6 68.7 19.5 68.5s17.3-31.2 16.5-69.3c-.8-38-9.6-68.7-19.5-68.5s-17.3 31.2-16.5 69.3z"
									data-name="Pfad 140"
								/>
								<path
									d="M-3306.1 665.4c.2 8.7 2.2 15.8 4.5 15.7 2.3 0 4-7.2 3.8-15.9s-2.2-15.8-4.5-15.7c-2.3 0-4 7.1-3.8 15.9z"
									data-name="Pfad 141"
								/>
								<path
									fill="#595f62"
									d="M-3443.3 603.7c.3 27.5 4.5 49.8 9.4 49.8s8.7-22.4 8.4-49.9-4.5-49.8-9.4-49.8-8.6 22.3-8.4 49.9z"
									data-name="Pfad 142"
								/>
								<path
									fill="#333535"
									d="M-3442.8 603.7c.3 26 4.2 47 8.9 46.9 4.6 0 8.2-21.1 7.9-47.1s-4.2-47-8.9-46.9c-4.6 0-8.1 21.1-7.9 47.1z"
									data-name="Pfad 143"
								/>
								<path
									d="M-3433.4 603.4c.1 6.7 1.1 12.2 2.3 12.2s2.1-5.5 2-12.2-1.1-12.2-2.3-12.2c-1.1 0-2.1 5.5-2 12.2z"
									data-name="Pfad 144"
								/>
								<path
									fill="#262626"
									d="M-2903.9 615.9l-141.5 5.1s-4 0-3.8 4c.3 4 2.1 31.8 2.1 31.8s-.7 2.8 3.9 2.5 141.8-6.4 141.8-6.4 3.1-.5 2.4-5.1c-.6-4.6-1.6-28.4-1.6-28.4s1.1-2.9-3.3-3.5z"
									data-name="Pfad 145"
								/>
								<path
									fill="#1e2021"
									d="M-2901.3 614l-141.5 5.1s-4 0-3.8 4c.3 4 2.1 31.8 2.1 31.8s-.7 2.8 3.9 2.5 141.8-6.4 141.8-6.4 3.1-.5 2.4-5.1c-.6-4.6-1.6-28.4-1.6-28.4s1.1-2.9-3.3-3.5z"
									data-name="Pfad 146"
								/>
								<path
									fill="#262626"
									d="M-2900 648.4c-.6-4.6-1.6-28.4-1.6-28.4s1-2.9-3.3-3.5l-141.5 5.1h-.3c.7-2.4 3.6-2.4 3.6-2.4l141.5-5.1c4.4.6 3.3 3.5 3.3 3.5s1 23.7 1.6 28.4c.6 4.6-2.4 5.1-2.4 5.1h-.9a23.691 23.691 0 0 0 0-2.7z"
									data-name="Pfad 147"
								/>
								<path fill="none" d="M-3267.351 585.334h103.265v61.084h-103.265z" />
							</g>
						</g>
						<g data-name="Gruppe 17">
							<path
								fill="#f6bda0"
								d="M-3079.6 642.6a19.279 19.279 0 0 0-27.2-3.1l-18.8 14.9c-16.7 13.3-23.5 27.1-11 43.1 12.4 16 27.4 11.8 44.1-1.5l18.8-14.9a19.279 19.279 0 0 0 3.1-27.2z"
								data-name="Pfad 149"
							/>
							<path
								fill="#f6bda0"
								d="M-3080.7 704.3c-11.5-14.2-24.6-2.5-30.5 2.1-5.9 4.5-10.6 8.2-10.6 8.2-11.8 9.1-14.8 24.9-6.7 35.3 8 10.4 24.1 11.4 35.8 2.3 3.9-3 7.5-5.8 10.6-8.2 5.9-4.5 21.2-14.7 6.8-32.7z"
								data-name="Pfad 150"
							/>
							<path
								fill="#f6bda0"
								d="M-3106.1 755.2c-11.7 9.3-23.3 24.6-12.7 38.5 11.1 14.4 27.1 6.2 35.7-6 11.5-16.4 7.6-23.4.2-32.7s-11.5-9.1-23.2.2z"
								data-name="Pfad 151"
							/>
							<path
								fill="#fff"
								d="M-3130.4 668.1c-8.9 8.7-8.9 7.5 4.4 22.1s9.7 12.9 19.6 5.4c15.1-11.2-9-42.2-24-27.5z"
								data-name="Pfad 152"
								opacity=".3"
							/>
							<path
								fill="#fff"
								d="M-3121.4 722.7c-7.8 7.7-9 3.3 2.3 18.3s10 12.5 19 6.1c12.9-9.1-6.9-38.7-21.3-24.4z"
								data-name="Pfad 153"
								opacity=".3"
							/>
							<path
								fill="#fff"
								d="M-3113.1 773.1c-6.2 6.1 10.9 25.7 16.9 19.3 15.4-16.6-5.5-30.6-16.9-19.3z"
								data-name="Pfad 154"
								opacity=".3"
							/>
						</g>
					</g>
					<g data-name="Gruppe 23">
						<path
							fill="#f6bda0"
							d="M-3181.6 1016.8c-9.5-37.6-21.9-47.8-30.9-58.3-9.8-11.5-24.4-10.2-35.3-3.2 1.7 8.1 17 60 27.1 113.1 17 27.4 71.7 73.9 71.7 73.9l22.8-92.4s-52.7-13.8-55.4-33.1z"
							data-name="Pfad 155"
						/>
						<path
							fill="#fff"
							d="M-3247.1 958c1.6 6.3 5.4 19.9 9.9 37.7 5.6-1.5 13.6-3.3 15.2-5.9 0 0-1.2-20.4-13-30.9-5.7-1.6-9.8-1.6-12.1-.9z"
							data-name="Pfad 156"
							opacity=".3"
						/>
						<path
							fill="#f6bda0"
							d="M-2917.4 1132.5c-15-69.1-34.6-114.9-36-118-3.4-7.9-23.3-55.8-26.7-58.8-8.7-7.8-33.9-15.5-35.9-12.8-12.5-30.5-30.4-30.4-40.3-28.8-3.7.9-15.5 3.5-20.2 7.1-7.2-17.6-21.1-20-25.1-20.8-17.9-.4-33.3 3.8-37.7 9.1-1.8 2.1-2.1 6.8-3.9 14.4-3.8-9-26-51.1-29.7-59.9-13.6-32.7-28.6-68.7-29.6-72.4-8.9-22.9-19.7-19.7-27-18.9-22.5 6.5-26.9 23.5 3.2 92.6 12.5 28.8 81.5 194 81.5 194s-10.1 48.6-4.1 82.7c44.7 32.7 91.4 52.9 111.6 63.7l139.4 169h176.2l45.9-.5z"
							data-name="Pfad 157"
						/>
						<g data-name="Gruppe 19" opacity=".33">
							<path
								fill="#f6bda0"
								d="M-2917.4 1132.5c-15-69.1-34.6-114.9-36-118-3.4-7.9-23.3-55.8-26.7-58.8-1.6-1.4 38.8 106.5 52 186.5l223.8 232.8h17.4l10.8-.5z"
								data-name="Pfad 158"
								opacity=".3"
							/>
						</g>
						<g data-name="Gruppe 20" opacity=".8">
							<path
								fill="#f6bda0"
								d="M-3139.7 910.2c-1.7 2.7-1.9 6.7-3.5 13.8.6 2.7 9 18.4 13 25.2a157.6 157.6 0 0 0 14 19.5c-8.9-16.9-21.5-53.1-23.1-57.3a5.633 5.633 0 0 1-.4-1.2z"
								data-name="Pfad 159"
								opacity=".3"
							/>
						</g>
						<g data-name="Gruppe 21" opacity=".8">
							<path
								fill="#f6bda0"
								d="M-3064.8 937.7c-1.1-3.4-2.7-6.3-3.9-9.7l-6.9-5.8c2.2 2.7 3.5 7.2 4.6 10.6 1.8 5.3 3.9 10.6 5.8 15.9 3.1 8.9 5 19.3 10.4 27 1.6-4.2-3.1-12.8-4.2-16.8-2-7-3.6-14.2-5.8-21.2z"
								data-name="Pfad 160"
								opacity=".3"
							/>
						</g>
						<g data-name="Gruppe 22" opacity=".8">
							<path
								fill="#f6bda0"
								d="M-3014 946l-2-3.2c.6 3.8 2.6 7.2 3.7 10.9 1 3.6 1.7 7.1 3 10.6.8 2.1 4.2 15.9 7 14.8.4-3.1-2.6-7.4-3.7-10.2-1.6-3.8-6.1-19.4-8-22.9z"
								data-name="Pfad 161"
								opacity=".3"
							/>
						</g>
						<path
							fill="#fff"
							d="M-3228.6 778.1c-13.1 4.5-14.2 7.9-9.6 21.3 3.8 11.1 8.4 15.7 22.1 10.7 11.8-4.9 13.5-4.5 9.6-16.6-4.2-12.7-6.8-20.6-22.1-15.4z"
							data-name="Pfad 162"
							opacity=".3"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
